export default {
  loading: true,
  projectTypes: [],
  brandDetectionModels: [],
}
